import React from 'react';

// ═══════════════════════════════════════════════════════════════════════
//  GARDE-FOU (Error Boundary)
//  Au lieu de laisser une page devenir blanche quand un composant plante,
//  ce composant attrape l'erreur et l'AFFICHE À L'ÉCRAN.
//  Utile pour diagnostiquer un crash qui ne se produit que sur certains
//  appareils (mobile Huawei, ancien navigateur...).
//
//  Usage : envelopper le composant suspect —
//      <ErrorBoundary>
//          <MonComposant />
//      </ErrorBoundary>
// ═══════════════════════════════════════════════════════════════════════

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, info: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        this.setState({ error, info });
        // Log aussi dans la console (visible en debug distant si disponible)
        console.error('ErrorBoundary a attrapé une erreur :', error, info);
    }

    render() {
        if (this.state.hasError) {
            const err = this.state.error;
            const message = err && err.message ? err.message : String(err);
            const stack = err && err.stack ? err.stack : '';
            const compStack = this.state.info && this.state.info.componentStack ? this.state.info.componentStack : '';

            return (
                <div style={{
                    padding: '20px',
                    margin: '20px',
                    border: '2px solid #b3123b',
                    borderRadius: '10px',
                    background: '#fff5f7',
                    color: '#1a0010',
                    fontFamily: 'monospace',
                    fontSize: '13px',
                    lineHeight: '1.6',
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap',
                }}>
                    <div style={{ fontWeight: 'bold', color: '#b3123b', fontSize: '15px', marginBottom: '12px' }}>
                        ⚠️ Une erreur est survenue sur cette page
                    </div>

                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Message :</div>
                    <div style={{ marginBottom: '12px', color: '#b3123b' }}>{message}</div>

                    {stack && (
                        <>
                            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Détail technique :</div>
                            <div style={{ marginBottom: '12px', fontSize: '11px', color: '#555' }}>{stack}</div>
                        </>
                    )}

                    {compStack && (
                        <>
                            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Composant :</div>
                            <div style={{ fontSize: '11px', color: '#555' }}>{compStack}</div>
                        </>
                    )}

                    <button
                        onClick={() => window.location.reload()}
                        style={{ marginTop: '16px', padding: '10px 20px', background: '#781840', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 'bold' }}
                    >
                        Recharger la page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;